// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6381cdbd","455":"19dcccd7"}[chunkId] + ".chunk.js";
};